import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LaunchDarklyFlag, LaunchDarklyService } from '@aiwyn/config';

// canMatch on the next-experience route; when the flag is off it falls through to the legacy detail.
@Injectable({ providedIn: 'root' })
export class EngagementsNextEnabledGuard {
  private readonly launchDarklyService = inject(LaunchDarklyService);

  canMatch(): Observable<boolean> {
    return this.launchDarklyService
      .getFeatureFlag(LaunchDarklyFlag.ENABLE_HTML_NATIVE_SIGNING_EXPERIENCE)
      .pipe(take(1));
  }
}
